import storage from './storage';
import { activityService } from './activityService';

const K = 'crm_offline_snapshot_v1';

function parseActivityDate(str) {
  if (!str) return null;
  const parts = String(str).split('.');
  if (parts.length === 3) return new Date(+parts[2], +parts[1] - 1, +parts[0]);
  return null;
}

function parseLeadActivityDe(str) {
  if (!str) return 0;
  const d = parseActivityDate(str);
  return d && !Number.isNaN(d.getTime()) ? d.getTime() : 0;
}

/** Letzte N Kontakte + Kurznotizen für Offline-Anzeige (PWA-light / Cache). */
export function buildOfflineSnapshot(leads, maxLeads = 45, notesPerLead = 4) {
  if (!Array.isArray(leads) || leads.length === 0) {
    storage.set(K, { at: Date.now(), leads: [], notesByLeadId: {} });
    return;
  }
  const sorted = [...leads]
    .sort((a, b) => parseLeadActivityDe(b.activity) - parseLeadActivityDe(a.activity))
    .slice(0, maxLeads);
  const slim = sorted.map(l => ({
    id: l.id,
    name: l.name,
    company: l.company,
    tel: l.tel,
    email: l.email,
    status: l.status,
    list: l.list,
    activity: l.activity,
    branch: l.branch,
  }));
  const notesByLeadId = {};
  for (const l of sorted) {
    const acts = activityService.getForLead(l.id).filter(a => a.type === 'note' || a.note);
    notesByLeadId[String(l.id)] = acts.slice(0, notesPerLead).map(a => ({
      id: a.id,
      date: a.date,
      by: a.by,
      text: (a.note || a.text || '').slice(0, 280),
    }));
  }
  storage.set(K, { at: Date.now(), leads: slim, notesByLeadId });
}

export function loadOfflineSnapshot() {
  return storage.get(K, { at: 0, leads: [], notesByLeadId: {} });
}
